import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { Subject } from "rxjs";
import Enrollment from "../../models/enrollment.model";
import { StudentService } from "../../services/student.service";
import Course from "../../models/course.model";
import { DialogInviteStudentComponent } from "../dialog-invite-student/dialog-invite-student.component";
import { NotificationService } from "../../services/notifications.service";

@Component({
  selector: "ngx-view-students",
  styleUrls: ["./view-students.component.scss"],
  templateUrl: "./view-students.component.html",
})
export class ViewStudentsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "admin"; //admin / course / home
  @Input() courseId?: string = "";
  @Input() course?: Course;

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: Enrollment[] = [];
  students?: Enrollment[] = [];

  pageSize = 50;
  strSearch = "";
  uid = "";

  constructor(
    private studentService: StudentService,
    public userService: UserService,
    private dialogService: NbDialogService,
    private router: Router,
    private notiService: NotificationService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.getStudents();
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore(): void {
    this.pageSize = 12;
    this.getStudents();
  }

  close() {}

  //Control event lazyloading
  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.students.filter(
      function (item) {
        return (
          item.author.displayName.toLowerCase().includes(this.strSearch) ||
          item.author.email.toLowerCase().includes(this.strSearch)
        );
      },
      { strSearch: this.strSearch }
    );
  }

  onNew() {
    let fbNew = new Enrollment();
    fbNew.courseId = this.courseId ? this.courseId : "";

    this.dialogService
      .open(DialogInviteStudentComponent, {
        context: {
          students: this.students,
          uid: this.uid,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          console.log("DialogInviteStudentComponent:", value);

          this.loading = true;
          this.studentService
            .inviteStudent(this.courseId, value.uid)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
              if (data) {
                console.log("inviteStudent:", data);
                //Send notification to tutor
                this.notiService.create(
                  "",
                  `/enrollments`,
                  data.id,
                  this.courseId,
                  `Mời tham gia khóa học`,
                  `${this.course.title}`,
                  value.uid,
                  `/student/courses/${data.id}/${this.courseId}`,
                  this.courseId
                );
              }

              this.loading = false;
            });
        }
      });
  }

  onDelete(value) {
    if (value) {
      remove(this.students, (e) => {
        return e.id == value;
      });
      this.display = [...this.students];
    }
  }

  private getStudents(): void {
    this.loading = true;

    this.studentService
      .getEnrollsByCourse(
        this.uid,
        this.courseId,
        "updatedOn",
        this.pageSize,
        this.cursor
      )
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
            createdOn: convertTimestamp(c.payload.doc.data().createdOn),
            updatedOn: convertTimestamp(c.payload.doc.data().updatedOn),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((dataRaw) => {
        console.log("getStudents:", dataRaw);

        if (dataRaw.length > 0) {
          this.cursor = dataRaw[dataRaw.length - 1].doc;
          this.done = dataRaw.length >= this.course.noStudent ? true : false;
        } else {
          this.cursor = null;
          this.done = true;
        }

        dataRaw.forEach((data) => {
          let item = find(this.students, ["id", data.id]);
          if (item) {
            item = data;
          } else {
            this.students.push(data);
          }
        });

        this.display = [...this.students];
        this.loading = false;
      });
  }
}
